export const HelpType = {
  ONBOARDING: "onboarding",
  LEARNING: "learning",
  RECRUITING: "recruiting",
  PERFORM: "performance",
};

export const defaultQuestionsByType = {
  [HelpType.LEARNING]: [
    "Review a completed course?",
    "Where is my training history?",
    "How can I get on a class waitlist?",
  ],
  [HelpType.RECRUITING]: [
    "How do I run a report?",
    "How do I create a job posting?",
    "How do I schedule an interview?",
  ]
};

export const onboardingQuestionsByPermission = {
  basic: [
    "Show me all my outstanding tasks.",
    "What's due this week?",
    "Which of my events still have outstanding work?",
  ],
  admin: [
    "Summarize the profile of an employee.",
    "Show me the uploaded documents for an employee.",
    "Show all tasks in \"Warning\" status.",
  ],
};

export const performanceQuestionsByRole = {
  basic: (reviewWriterEnabled) => reviewWriterEnabled
    ? [
        "How do I initiate a check-in meeting?",
        "Show me my past reviews",
        "Help me write a self-review",
      ]
    : [
        "How do I start my self-review?",
        "How do I initiate a check-in meeting?",
        "How do I provide feedback?",
      ],
  manager: (reviewWriterEnabled) => [
    "View all reviews for an employee.",
    reviewWriterEnabled
      ? "Help me write a performance review for a member of my team."
      : "Show me my reviews and feedback",
    "Get guidance on giving feedback to a direct report.",
  ],
  admin: [
    "Show me company-wide feedback stats.",
    "Tell me the overall goal completion rate.",
    "Give me all reviews for an employee.",
  ],
};

export const greetingMessagesByType = {
  [HelpType.LEARNING]: "Hello! I'm ROSI. How can I assist with your Learn inquiries today? Feel free to ask me anything, or choose one of these options to get started:",
  [HelpType.RECRUITING]: "Hello! I'm ROSI. How can I assist with your Recruit inquiries today? Feel free to ask me anything, or choose one of these options to get started:",
  [HelpType.PERFORM]: "Hello! I'm ROSI, I can help with your performance insights. Ask me a question or choose an option to begin.",
};

export const onboardingGreetingByPermission = {
  basic: "Hi, I'm ROSI, your dedicated AI assistant. I can help you check your tasks, upcoming events, or provide real-time insights to support your work. What would you like to do today?",
  admin: "Hi, I'm ROSI, your dedicated AI agent. I can offer real-time insights for your organization or answer product-related inquiries. How can I help?",
};

export const helpPageLinksByType = {
  [HelpType.ONBOARDING]: "https://workflow-help.rival-hr.com/",
  [HelpType.LEARNING]: "https://learn-help.rival-hr.com/",
  [HelpType.RECRUITING]: "https://recruiting-help.rival-hr.com/",
  [HelpType.PERFORM]: "https://perform-help.rival-hr.com/",
};
